import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { InMemoryScrollingFeature, InMemoryScrollingOptions, provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, PB_DIRECTION } from 'ngx-ui-loader';
import { provideStore } from '@ngrx/store';
import { rootReducer } from './components/Theme/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MessageService } from 'primeng/api';
import { RequestsHandlerInterceptor } from './services/requestsHandler.interceptor';
import { GlobalConstants } from './globalConstants';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { routes } from './app-routing.module';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/');
}

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

const ngxuiLoaderConfig: NgxUiLoaderConfig = {
  textPosition: "center-center",
  pbColor: "white",
  bgsColor: "white",
  fgsColor: "white",
  fgsType: SPINNER.threeBounce,
  fgsSize: 80,
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 5
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, inMemoryScrollingFeature),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideStore(rootReducer),
    provideStoreDevtools(),
    provideAnimationsAsync(),
    MessageService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: RequestsHandlerInterceptor, multi: true },
    { provide: MAT_DATE_FORMATS, useValue: GlobalConstants.MY_DATE_FORMATS },
    importProvidersFrom(
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        NgxUiLoaderModule.forRoot(ngxuiLoaderConfig)
    )
  ]
};